import {
	Component,
	ElementRef,
	EventEmitter,
	AfterViewInit,
	AfterViewChecked,
	Input,
	OnChanges,
	Output,
} from "@angular/core";
import { GridLayout } from "../../../../insa-models/grid-layout.model";
import { GridLayoutService } from "../gird-layout.service";
import { LocalizeService } from "../../../../insa-services";

@Component({
	selector: "grid-wizard",
	template: `<div
		id="grid-wizard-modal"
		class="modal fade"
		tabindex="-1"
		role="dialog"
		data-backdrop="static"
		data-keyboard="false"
	>
		<div class="modal-dialog grid-wizard-container">
			<div class="modal-content modal-loading">
				<div class="modal-header">
					<h2 class="modal-title grid-wizard-title" localize="Res479">
						Grid wizard
					</h2>
					<button
						(click)="closeModal()"
						type="button"
						class="close"
						aria-label="Close"
					>
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div
					class="modal-header"
					style="display: flex; align-items: center; flex-grow: 1; flex-wrap: wrap; align-items: stretch;"
				>
					<ng-container *ngIf="layouts && !newLayout">
						<div
							style="display: flex; flex-grow: 1; justify-content: flex-start; align-items: baseline"
						>
							<div style="display: flex; align-items: center" localize="Res478">
								Template
							</div>
							<select
								*ngIf="layouts && layouts.length"
								(change)="selectLayout($event.target.value)"
								class="btn btn-default"
								style="margin-left: 0.5rem; max-width: 7rem;"
							>
								<option [selected]="!selectedLayout" value="" disabled hidden>
									...
								</option>
								<option
									*ngFor="let layout of layouts"
									[selected]="
										selectedLayout && selectedLayout.name === layout.name
									"
									value="{{ layout.name }}"
									[value]="layout.name"
								>
									{{ layout.name || unnamedText }}
								</option>
							</select>
							<span
								*ngIf="selectedLayout && selectedLayout.isClientDefault"
								style="margin: 0 1rem; align-self: center; color: blue;"
								localize="Res1135"
								>Client default</span
							>
							<button
								style="margin-left: 0.5rem;"
								(click)="createNewLayout()"
								type="button"
								class="btn btn-primary"
								localize="Res475"
							>
								Save as
							</button>
						</div>
						<div
							style="display: flex; flex-grow: 1; justify-content: flex-end; align-items: baseline"
						>
							<button
								*ngIf="selectedLayout"
								(click)="deleteSelectedLayout()"
								style="margin-left: 0.5rem;"
								type="button"
								class="btn btn-danger"
								localize="Res5"
							>
								Delete
							</button>
						</div>
					</ng-container>
					<ng-container *ngIf="layouts && newLayout">
						<input
							[(ngModel)]="newLayout.name"
							class="input"
							style="margin-top: 0.5rem;"
							type="text"
							[placeholder]="newLayoutPlaceholder"
							style="margin-left: 0.5rem;"
						/>
						<div style="display: none;">
						<label
							for="isClientDefault"
							style="margin: 0 0.5rem 0 1rem; align-self: center;"
							localize="Res1135"
							>Client default</label
						><input
							id="isCustomerDefault"
							[(ngModel)]="newLayout.isClientDefault"
							type="checkbox"
							style="margin: 0 1rem 0 0; align-self: center;"
						/>
						</div>
						<button
							(click)="saveLayout()"
							style="margin-left: 0.5rem;"
							type="button"
							class="btn btn-primary"
							localize="Res21"
						>
							Save
						</button>
						<button
							(click)="cancelNewLayout()"
							style="margin-left: 0.5rem;"
							type="button"
							class="btn btn-default"
							localize="Res3"
						>
							Cancel
						</button>
					</ng-container>
				</div>
				<div class="modal-body">
					<ul class="chronos-navigation nav nav-tabs tab-nav" role="tablist">
						<li [class.active]="this.editMode === 'columns'">
							<a
								aria-controls="columns"
								role="tab"
								data-toggle="tab"
								class="nav-item nav-link"
								(click)="this.editMode = 'columns'"
								><span localize="Res477">Columns</span
								>{{ isColumnsModified ? "*" : "" }}</a
							>
						</li>
						<li [class.active]="this.editMode === 'groups'">
							<a
								aria-controls="minutes"
								role="tab"
								data-toggle="tab"
								class="nav-item nav-link"
								(click)="this.editMode = 'groups'"
								><span localize="Res476">Groups</span
								>{{ isGroupModified ? "*" : "" }}</a
							>
						</li>
					</ul>
					<div class="tab-content" id="pills-tabContent">
						<grid-wizard-row
							(onChange)="detectChanges()"
							*ngIf="currWizardOptions"
							[settings]="currWizardOptions"
							[editMode]="editMode"
						></grid-wizard-row>
					</div>
				</div>

				<div class="modal-footer" style="display: flex;">
					<div
						style="display: flex; flex-grow: 1; justify-content: flex-end; align-items: baseline"
					>
						<button
							(click)="closeModal()"
							type="button"
							class="btn btn-secondary"
							localize="Res4502"
						>
							Close
						</button>
						<button
							(click)="applyLayout()"
							type="button"
							class="btn btn-primary"
							localize="Res1136"
						>
							Apply
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>`,
})
export class GridWizardComponent
	implements OnChanges, AfterViewInit, AfterViewChecked
{
	@Input() isVisible: boolean = false;
	@Input() gridName: string;
	@Input() metadataName: string;

	private _viewInitialized: boolean = false;
	private _pendingVisible: boolean = false;
	private _needsTranslation: boolean = false;

	@Output() onInitialLayoutReady = new EventEmitter();
	@Output() onCloseModal = new EventEmitter();
	@Output() onApplyGridSettings = new EventEmitter();

	layouts: GridLayout[] = [];
	selectedLayout: GridLayout = {} as GridLayout;
	currWizardOptions: kendo.ui.GridOptions;
	currGridOptions: kendo.ui.GridOptions;
	editMode: "columns" | "groups" = "columns";
	isColumnsModified: boolean = false;
	isGroupModified: boolean = false;
	isLayoutModified: boolean = false;
	newLayout: GridLayout;

	constructor(
		private _gridLayoutService: GridLayoutService,
		private _localize: LocalizeService,
		private _element: ElementRef,
	) {
		this.detectColumnsChange = this.detectColumnsChange.bind(this);
		this.detectGroupChange = this.detectGroupChange.bind(this);
	}

	get unnamedText(): string {
		return this._localize.getLocalizedResource("Res1139") || "unnamed";
	}

	get newLayoutPlaceholder(): string {
		return this._localize.getLocalizedResource("Res1134") || "New layout name";
	}

	ngAfterViewChecked() {
		if (this._needsTranslation) {
			this._needsTranslation = false;
			this._localize.applyTranslations(this._element.nativeElement);
		}
	}

	createNewLayout() {
		this.newLayout = {
			name: this.selectedLayout ? this.selectedLayout.name : "",
			isClientDefault: this.selectedLayout
				? this.selectedLayout.isClientDefault
				: false,
			options: this.currWizardOptions,
		};
		this._needsTranslation = true;
	}

	cancelNewLayout() {
		this.newLayout = null;
		this._needsTranslation = true;
	}

	detectChanges() {
		const isColumnsModified = this.detectColumnsChange();
		const isGroupModified = this.detectGroupChange();

		this.isColumnsModified = isColumnsModified;
		this.isGroupModified = isGroupModified;
		this.isLayoutModified = isColumnsModified || isGroupModified;
	}

	detectColumnsChange() {
		const items1 = this.selectedLayout
			? this.selectedLayout.options.columns
			: this.currGridOptions.columns;
		const items2 = this.currWizardOptions.columns;

		let isModified = false;
		items1.forEach((item1, i) => {
			if (
				item1.field !== items2[i].field ||
				item1.hidden !== items2[i].hidden
			) {
				isModified = true;
			}
		});

		items2.forEach((item2, i) => {
			if (
				item2.field !== items1[i].field ||
				item2.hidden !== items1[i].hidden
			) {
				isModified = true;
			}
		});

		return isModified;
	}

	detectGroupChange() {
		const items1 = this.selectedLayout
			? this.selectedLayout.options.dataSource.group
			: this.currGridOptions.dataSource.group;
		const items2 = this.currWizardOptions.dataSource.group;

		let isModified = false;
		if (items1.length !== items2.length) {
			return true;
		}

		items1.forEach((item1, i) => {
			if (item1.field !== items2[i].field) {
				isModified = true;
			}
		});

		items2.forEach((item2, i) => {
			if (item2.field !== items1[i].field) {
				isModified = true;
			}
		});

		return isModified;
	}

	saveLayout() {
		kendo.ui.progress($(".modal-loading"), true);
		let saveAction;
		if (this.layouts.find((lyt) => lyt.name === this.newLayout.name)) {
			saveAction = this._gridLayoutService.updateLayout;
		} else {
			saveAction = this._gridLayoutService.createLayout;
		}

		saveAction(this.gridName, this.metadataName, this.newLayout).subscribe(
			() => {
				this._gridLayoutService
					.readLayouts(this.gridName, this.metadataName)
					.subscribe((customLayouts) => {
						kendo.ui.progress($(".modal-loading"), false);
						this.layouts = customLayouts;
						this.selectLayout(this.newLayout.name);
						this.newLayout = null;
						this._needsTranslation = true;
					});
			},
		);
	}

	applyLayout() {
		this.onApplyGridSettings.emit(
			JSON.parse(JSON.stringify(this.currWizardOptions)),
		);
		this.closeModal();
	}

	selectLayout(layoutName) {
		this.selectedLayout = JSON.parse(
			JSON.stringify(this.layouts.find((t) => t.name === layoutName)),
		);
		this.currWizardOptions = JSON.parse(
			JSON.stringify(this.selectedLayout.options),
		);
		this.newLayout = null;
		this.detectChanges();
	}

	deleteSelectedLayout() {
		kendo.ui.progress($(".modal-loading"), true);
		this._gridLayoutService
			.deleteLayout(this.gridName, this.metadataName, this.selectedLayout.name)
			.subscribe(() => {
				this._gridLayoutService
					.readLayouts(this.gridName, this.metadataName)
					.subscribe((customLayouts) => {
						this.layouts = customLayouts;
						kendo.ui.progress($(".modal-loading"), false);
						this.selectedLayout = null;
					});
			});
	}

	closeModal() {
		this.onCloseModal.emit();
	}

	makeCurrentGridOptions() {
		const kendoGrid = $("#" + this.gridName).data("kendoGrid");
		const options = JSON.parse(JSON.stringify(kendoGrid.getOptions()));
		options.columns = options.columns.filter((col) => col.field);
		options.columns.forEach((col) => {
			if (col.attributes) {
				col.attributes = null;
			}
			if (col.footerAttributes) {
				col.footerAttributes = null;
			}
			if (col.headerAttributes) {
				col.headerAttributes = null;
			}
		});
		return options;
	}

	ngOnChanges(changes) {
		if (changes.isVisible && changes.isVisible.currentValue !== undefined) {
			this._pendingVisible = this.isVisible;
			if (this._viewInitialized) {
				this._toggleGridWizardModal(this.isVisible);
			}
			if (this.isVisible) {
				this.currGridOptions = this.makeCurrentGridOptions();
				this.currWizardOptions = JSON.parse(
					JSON.stringify(this.currGridOptions),
				);
				kendo.ui.progress($(".modal-loading"), true);
				this._gridLayoutService
					.readLayouts(this.gridName, this.metadataName)
					.subscribe(
						(customLayouts) => {
							this.layouts = customLayouts;
							this.selectedLayout = null;
							kendo.ui.progress($(".modal-loading"), false);
							this.detectChanges();
							this._needsTranslation = true;
						},
						() => {
							// error
						},
					);
			}
		}
	}

	ngAfterViewInit() {
		this._viewInitialized = true;
		if (this._pendingVisible) {
			this._toggleGridWizardModal(this._pendingVisible);
		}
	}

	private _toggleGridWizardModal(isVisible: boolean) {
		setTimeout(() => {
			const modal = $("#grid-wizard-modal");
			const hasPlugin = modal.length && typeof modal.modal === "function";

			if (!modal.length) {
				console.warn("GridWizard modal element not found in DOM yet");
				return;
			}

			if (isVisible) {
				if (hasPlugin) {
					modal.modal("show");
				} else {
					modal.addClass("show").css({ display: "block" });
					if (!$(".modal-backdrop").length) {
						$("<div class='modal-backdrop fade show'></div>").appendTo("body");
					}
				}
			} else {
				if (hasPlugin) {
					modal.modal("hide");
				} else {
					modal.removeClass("show").hide();
					$(".modal-backdrop").remove();
				}
			}
		}, 0);
	}
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-generic-form/generic-grid/components/grid-wizard.component.ts